export const featureFlags = {
  useUnifiedContent: process.env.EXPO_PUBLIC_USE_UNIFIED_CONTENT === 'true',
} as const;

export type FeatureFlags = typeof featureFlags;

export function isUnifiedContentEnabled(): boolean {
  return featureFlags.useUnifiedContent;
}
